import getEnv from "../utils/getEnv";

const colorConfig = {
  primaryColor: getEnv('REACT_APP_PRIMARY_COLOR') || 'blue.600',
  secondaryColor: getEnv('REACT_APP_SECONDARY_COLOR') || 'blue.200',
}

export default colorConfig;